<template>
  <div class="external-booking-rooms">
    <button @click="redirectToExternalSite" class="btn btn-link external-booking-rooms__icon-button">
      <i class="icon xl color-primary external-booking-rooms__icon icon-hotel-external"/>
    </button>
    <div class="external-booking-rooms__message">
      <span class="external-booking-rooms__title">{{ translate('rdEbModalTitle')}}</span>
      <span class="external-booking-rooms__description">{{ translate('rdEbModalDescription')}}</span>
    </div>
    <Button class="external-booking-rooms__button"  @click="redirectToExternalSite">
      <span class="external-booking-rooms__button-label">{{ translate('rdEbModalCTA').toUpperCase() }}</span>
    </Button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ExternalHotelInfo from '../room-rate-display/domain/ExternalHotelInfo'

const { mapGetters } = createNamespacedHelpers('roomRateDisplay')

export default {
  name: 'ExternalBookingRooms',
  props: {
    externalHotelInfo: ExternalHotelInfo
  },
  computed: {
    ...mapGetters(['getSearchData'])
  },
  methods: {
    generateExternalUrl () {
      let url = this.externalHotelInfo.url
      const searchData = this.getSearchData
      Object.keys(searchData).forEach((key) => {
        url = url.replace(`{${key}}`, searchData[key])
      })

      return url
    },
    redirectToExternalSite () {
      const externalUrl = this.generateExternalUrl()
      global.TrackingService.track(global.trackingEvents.EXTERNAL_HOTEL)
      window.location.replace(externalUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.external-booking-rooms {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 5rem 3rem;

  &__icon {
    cursor: pointer;
  }

  &__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 0;
  }

  &__title {
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
  }

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 14.5px;
    line-height: 30px;
    text-align: center;
  }

  &__button {
    background-color: rgb(194, 8, 8);
    width: 109px;
    height: 60px;
    border-radius: 4px;
    border: none;
  }

  &__button-label {
    color: white;
    font-size: 14px;
    font-weight: 350;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: center;

  }

  &__icon-button {
    outline: none;
    box-shadow: none;
  }
}
</style>
